export default {
  manage_keyFob: "Llavero",
  manage_keyFobs: "Llaveros",
  manage_driver: "Conductor",
  manage_keyFobs_search_by_key_fob_number: "Buscar por Llavero y Conductor"
};
